<template>
	<div class="main-container">
		<LogoComponent
            @click="sharedState.onboardingPage === 0 ? $router.push('/') : $router.push('business/login')"
		/>
		<transition-group name="fade">
			<SignUpComponent
				v-if="sharedState.onboardingPage === 0"
				@signup="onSignUp"
				v-model="user"
				:key="0"
			/>
			<AdEditComponent
				v-if="sharedState.onboardingPage === 1"
				@back="onBack"
				@adFinished="onAdFinished"
				:key="2"
			/>
		</transition-group>
	</div>
</template>

<script>
import LogoComponent from "@/components/LogoComponent";
import AdEditComponent from "@/components/AdEditComponent";
import SignUpComponent from "@/components/SignUpComponent";
import store from '@/services/business/store';

export default {
	name: "OnboardingPage",
	components: {
		LogoComponent,
		AdEditComponent,
		SignUpComponent
	},
	data: () => {
		return {
			adInfo: null,
			user: null,
			quantity: 1,
			sharedState: store.state
		};
	},
	created() {
		store.setStripe();
	},
	methods: {
        onAdFinished() {
			// store.setAdInfo(e);
			store.createSpot(this.sharedState.adInfo, this.sharedState.checkoutSession.id);
		},
		onSignUp(e) {
			store.setUserInfo(e);
			this.$cookies.remove('csrftoken');
			this.$cookies.remove('sessionid');
			store.signUp(this.sharedState.user, this.$route.query.session);
		},
		onBack() {
			store.previousOnboardingPage();
		}
	}
};
</script>

<style lang="scss" scoped>
	.main-container {
		height: 100vh;
		width: 100vw;

		/* base */
		.fade {
			backface-visibility: hidden;
			z-index: 1;
		}

		/* moving */
		.fade-move {
			transition: all 600ms ease-in-out 50ms;
		}

		/* appearing */
		.fade-enter-active {
			transition: all 400ms ease-out;
		}

		/* disappearing */
		.fade-leave-active {
			transition: all 200ms ease-in;
			position: absolute;
			z-index: 0;
		}

		/* appear at / disappear to */
		.fade-enter,
		.fade-leave-to {
			opacity: 0;
		}
	}
</style>